module.exports = __webpack_public_path__ + "img/Valladolid-logo-icon.2171e95e.png";